import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const CATEGORY_API_REDUCER_KEY = "categoryApi";

export const categoryApi = createApi({
  reducerPath: CATEGORY_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["category"],
  endpoints: (builder) => ({
    getCategoryList: builder.query({
      query: ({ page, limit }) => {
        return {
          url: `emissions/emission-categories/?page=${page}&limit=${limit}`,
        };
      },
      providesTags: ["category"],
    }),

    getCategoriesEmissions: builder.query({
      query: ({ year, start_date, node, end_date }) => {
        // Construct the base URL
        let url = `/emissions/category-wise-total-emission/?limit=20`;

        // Append parameters if they are provided
        if (year) {
          url += `&year=${year}`;
        }
        if (start_date) {
          url += `&start_date=${start_date}`;
        }
        if (end_date) {
          url += `&end_date=${end_date}`;
        }
        if (node) {
          url += `&node=${node}`;
        }

        return {
          url,
        };
      },
      providesTags: ["category"],
    }),

    getEmissionsCategories: builder.query({
      query: () => {
        return {
          url: `/emissions/emission-categories/`,
        };
      },
      providesTags: ["category"],
    }),
    getCategory: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `emissions/emission-categories/${id}/`,
        };
      },
      providesTags: ["category"],
    }),

    createCategory: builder.mutation({
      query: (body) => ({
        url: `emissions/emission-categories/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["category"],
    }),
    updateCategory: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `emissions/emission-categories/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["category"],
    }),

    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `emissions/emission-categories/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["category"],
    }),
    getCategories: builder.query({
      query: ({ page, limit }) => {
        return {
          url: `emissions/emission-categories`,
        };
      },
      providesTags: ["category"],
    }),

  }),
});

export const {
  useCreateCategoryMutation,
  useDeleteCategoryMutation,
  useUpdateCategoryMutation,
  useGetCategoryQuery,
  useGetCategoryListQuery,
  useGetEmissionsCategoriesQuery,
  useGetCategoriesEmissionsQuery,
  useGetCategoriesQuery,
} = categoryApi;
